import request from '@/utils/request';
const base_path = '/material/report/gdt';

/**
 * 重导广点通素材报表数据
 * @param {Object} params 查询参数
 * @returns {Promise<Object>}
 */
export function pullGdtMaterialReportApi(params) {
  return request({
    url: `${base_path}/pull`,
    method: 'get',
    params,
  });
}
